import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import { useState } from 'react'
import ECharts from '~/components/echarts'
import {
  azureReservationManagementChartOrganizationOptimizerAzureMasterOptimizationsPath,
  azureVmCostAnalysisChartOrganizationOptimizerAzureMasterOptimizationsPath,
  azureVmSkuCurrentChartOrganizationOptimizerAzureMasterOptimizationsPath,
  azureVmSkuOptimizedChartOrganizationOptimizerAzureMasterOptimizationsPath,
} from '~/routes'

export default function VMOptimization({ organizationId, masterOptimizationId, masterOptimization }) {
  const [activeTab, setActiveTab] = useState('daily-cost')

  if (!masterOptimization) {
    return (
      <div className='row mb-4'>
        <div className='col-12'>
          <div className='card'>
            <div className='card-header'>
              <h5 className='card-title mb-0'>
                <Trans>Azure VM Optimization</Trans>
              </h5>
            </div>
            <div className='card-body'>
              <div className='text-center text-muted'>
                <p>
                  <Trans>Loading VM optimization data...</Trans>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const handleTabChange = (tabId) => {
    setActiveTab(tabId)
  }

  return (
    <div className='row mb-4'>
      <div className='col-12'>
        <div className='card'>
          <div className='card-header'>
            <div className='d-flex justify-content-between align-items-center'>
              <h5 className='card-title mb-0'>
                <Trans>Azure VM Optimization</Trans>
              </h5>
            </div>
          </div>
          <div className='card-body'>
            <ul className='nav nav-tabs'>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${activeTab === 'daily-cost' ? 'active' : ''}`}
                  onClick={() => handleTabChange('daily-cost')}
                  type='button'
                  role='tab'
                >
                  <Trans>Cost Analysis</Trans>
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${activeTab === 'vm-sku' ? 'active' : ''}`}
                  onClick={() => handleTabChange('vm-sku')}
                  type='button'
                  role='tab'
                >
                  <Trans>VM SKU Charts</Trans>
                </button>
              </li>
              <li className='nav-item' role='presentation'>
                <button
                  className={`nav-link ${activeTab === 'reservation-management' ? 'active' : ''}`}
                  onClick={() => handleTabChange('reservation-management')}
                  type='button'
                  role='tab'
                >
                  <Trans>Reservation Management</Trans>
                </button>
              </li>
            </ul>

            <div className='mt-3'>
              {activeTab === 'daily-cost' && (
                <ECharts
                  title={t`Daily Cost Comparison`}
                  chartInfoTitle='azure_vm_optimization_daily_cost_comparison'
                  url={azureVmCostAnalysisChartOrganizationOptimizerAzureMasterOptimizationsPath(organizationId)}
                  params={{ master_optimization_id: masterOptimizationId }}
                />
              )}

              {activeTab === 'vm-sku' && (
                <div className='row'>
                  <div className='col-md-6'>
                    <ECharts
                      title={t`Current VM SKUs`}
                      chartInfoTitle='azure_vm_current_vm_skus'
                      url={azureVmSkuCurrentChartOrganizationOptimizerAzureMasterOptimizationsPath(organizationId)}
                      params={{ master_optimization_id: masterOptimizationId }}
                    />
                  </div>
                  <div className='col-md-6'>
                    <ECharts
                      title={t`Optimized VM SKUs`}
                      chartInfoTitle='azure_vm_optimized_vm_skus'
                      url={azureVmSkuOptimizedChartOrganizationOptimizerAzureMasterOptimizationsPath(organizationId)}
                      params={{ master_optimization_id: masterOptimizationId }}
                    />
                  </div>
                </div>
              )}

              {activeTab === 'reservation-management' && (
                <ECharts
                  title={t`Reservation Management`}
                  chartInfoTitle='azure_vm_reservation_management'
                  url={azureReservationManagementChartOrganizationOptimizerAzureMasterOptimizationsPath(organizationId)}
                  params={{ master_optimization_id: masterOptimizationId }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
